// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

class InputText extends React.PureComponent {
  render() {
    const { inputRef, ...props } = this.props
    return tag('input', {
      ...props,
      ref: inputRef
    })
  }
}

InputText.propTypes = {
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}

InputText.defaultProps = {
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: 'false',
  type: 'text'
}

module.exports = InputText
